import { useState } from "react";
import { motion } from "framer-motion";
import { COUNTRY_PATHS, MILAN, MAP_W, MAP_H } from "@/data/europePaths";

export default function EuropeMap() {
  const [hovered, setHovered] = useState(null);

  return (
    <div className="relative" data-testid="europe-map">
      <svg viewBox={`0 0 ${MAP_W} ${MAP_H}`} className="w-full h-auto" role="img" aria-label="Map of Europe with ACTIVE headquarters in Milan">
        {COUNTRY_PATHS.map((c, i) => {
          const isHQ = c.code === "ITA";
          return (
            <motion.path
              key={c.code}
              d={c.d}
              fill={isHQ ? "#B02942" : hovered === c.code ? "#DCE3EB" : "#EDF1F5"}
              stroke="#FFFFFF"
              strokeWidth={1.2}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: Math.min(i * 0.02, 0.6), duration: 0.5 }}
              className="cursor-pointer transition-colors duration-200"
              onMouseEnter={() => setHovered(c)}
              onMouseLeave={() => setHovered(null)}
              data-testid={`map-country-${c.code.toLowerCase()}`}
            />
          );
        })}

        <motion.circle
          cx={MILAN.x}
          cy={MILAN.y}
          r={7}
          fill="none"
          stroke="#FFFFFF"
          strokeWidth={1.6}
          style={{ transformBox: "fill-box", transformOrigin: "center" }}
          initial={{ scale: 1, opacity: 0.9 }}
          animate={{ scale: 2.6, opacity: 0 }}
          transition={{ duration: 2.4, repeat: Infinity, ease: "easeOut" }}
        />
        <circle
          cx={MILAN.x}
          cy={MILAN.y}
          r={6}
          fill="#FFFFFF"
          stroke="#B02942"
          strokeWidth={3}
          data-testid="map-hq-milan"
        />
        <g>
          <rect x={MILAN.x + 14} y={MILAN.y - 34} rx={7} width={112} height={28} fill="#0A0B0D" />
          <text x={MILAN.x + 27} y={MILAN.y - 15.5} fontSize="10.5" fill="#FFFFFF" fontFamily="IBM Plex Mono, monospace" letterSpacing="1.5">
            MILANO · HQ
          </text>
        </g>
      </svg>

      <div className="absolute bottom-4 left-4 rounded-lg border border-slate-200 bg-white/85 px-4 py-3 backdrop-blur-md" data-testid="map-info-chip">
        {hovered ? (
          <>
            <p className="font-display font-semibold text-sm text-slate-950">{hovered.name}</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] mt-0.5">
              <span className={hovered.code === "ITA" ? "text-signal" : "text-slate-500"}>
                {hovered.code === "ITA" ? "● ACTIVE Headquarters" : "○ Territory open"}
              </span>
            </p>
          </>
        ) : (
          <>
            <p className="font-display font-semibold text-sm text-slate-950">Europe</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] mt-0.5 text-slate-500">
              HQ Milan · Territories open
            </p>
          </>
        )}
      </div>
    </div>
  );
}
